<template>
  <button
    class="c-book-page-star"
    v-bind:class="{active: isActive, left: isLeft, right: !isLeft}"
    v-on:click="$emit('star-click')"
    :aria-label="isActive ? `${$t('REMOVE_FROM_FAVORITES')}` : `${$t('ADD_TO_FAVORITES')}`"
    :aria-pressed="isActive ? 'true' : 'false'">
    <star-icon class="c-book-page-star__icon" :isFilled="isActive"></star-icon>
  </button>
</template>

<script>
import StarIcon from '@/assets/svg/StarIcon'

export default {
  name: 'BookPageStar',

  components: {
    'star-icon': StarIcon
  },

  props: {
    isActive: Boolean,
    isLeft: Boolean
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

  .c-book-page-star {
    position: absolute;
    width: 60px;
    height: 60px;
    background-color: $light-grey-blue;
    top: 24px;
    cursor: pointer;
    z-index: 0;
    border: 0;

    @include a11yOutline();
  }

  .c-book-page-star:hover,
  .c-book-page-star.active {
    background-color: $orange;
    opacity: 0.5;
  }

  .c-book-page-star.active {
    opacity: 1;
  }

  .c-book-page-star:focus {
    outline: thin dotted $orange;
    outline: 4px auto -webkit-focus-ring-color;
    outline-offset: -2px;
  }

  .c-book-page-star.left {
    left: -60px;
    border-radius: 20px 0 0 20px;
  }

  .c-book-page-star.right {
    right: -60px;
    border-radius: 0 20px 20px 0;
  }

  .c-book-page-star__icon {
    display: block;
    margin: auto;
    position: relative;
  }
</style>
